/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCharityRunTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCharityRun,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Run for a Cause!",
    "Charity Run Awaits!",
    "Let’s Make a Difference!",
  ],
  title: "Charity Run",
  description: "Organize a meaningful charity run.",
  longDescription:
    "Gather your friends for a charity run to raise funds! Choose a date, plan the route, and decide on activities for the event!",
  emoji: "🏃",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Charity Run",
          emoji: "🏃",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the charity run?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the route?",
            description: "What route should we take for the charity run?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What routes should we consider?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on fundraising activities?",
                  description:
                    "What activities should we include to raise funds?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Make a Difference!",
    outroDescription: "Your charity run plans are set! Enjoy the run!",
  },
};
